export default (eventData) => {
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || []

    if(window.queuedDataLayer) {
      window.queuedDataLayer.push(eventData)
    } else {
      window.dataLayer.push(eventData)
    }
  }
}